import { render } from "./mode_channel.vue?vue&type=template&id=9e94521e&ts=true"
import script from "./mode_channel.vue?vue&type=script&lang=ts"
export * from "./mode_channel.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/mode_channel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e94521e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e94521e', __exports__)) {
    api.reload('9e94521e', __exports__)
  }
  
  module.hot.accept("./mode_channel.vue?vue&type=template&id=9e94521e&ts=true", () => {
    api.rerender('9e94521e', render)
  })

}


export default __exports__